import { useMutation } from '@apollo/client'
import { useEffect } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { NewRoute } from 'features/Routes/components/NewRoute'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite } from 'features/Users/utils'
import { CREATE_ROUTE_V2 } from 'features/Routes/mutations-legacy'
import FormLayout from 'components/v2/FormLayout'
import { routeFormUtils } from 'features/Routes/utils'
import { IRouteDirection } from 'features/Routes/types'
import { useLogin } from 'features/Login/hooks'

const messages = defineMessages({
  helmet: {
    id: 'routes.new.helmet',
    defaultMessage: 'New Route | Nexbus Admin'
  }
})

const NewRouteView = (): TSFixMe => {
  const navigate = useNavigate()
  const intl = useIntl()
  const login = useLogin()

  useEffect((): TSFixMe => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  const [createRouteV2, { data, loading, error }] = useMutation(CREATE_ROUTE_V2, {
    onError: (): void => {
      // Do nothing
    }
  })

  const handleSubmit = (formValues: TSFixMe): void => {
    createRouteV2({
      variables: {
        input: routeFormUtils.mapFormToCreateMutationV2(formValues)
      }
    })
    if (formValues.direction === IRouteDirection.OUTBOUND) {
      createRouteV2({
        variables: {
          input: routeFormUtils.mapFormToCreateMutationV2(formValues, IRouteDirection.OUTBOUND)
        }
      })
    }
  }

  useEffect(() => {
    if (data) {
      navigate('/routes')
    }
  }, [data])

  if (!canWrite(FEATURES.ROUTE, login.accessToken.policies)) {
    return <ForbiddenView feature={FEATURES.ROUTE} />
  }

  return (
    <FormLayout.Container>
      <NewRoute onSubmit={handleSubmit} loading={loading} error={error} />
    </FormLayout.Container>
  )
}

export default withLastUrl(NewRouteView)
